var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 9.25C6.59721 9.25 8.5 7.34721 8.5 5C8.5 2.65279 6.59721 0.75 4.25 0.75C1.90279 0.75 0 2.65279 0 5C0 7.34721 1.90279 9.25 4.25 9.25Z",
    stroke: "#7F7F7F",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5H4.375C4.34185 5 4.31005 4.98683 4.28661 4.96339C4.26317 4.93995 4.25 4.90815 4.25 4.875V3.25",
    stroke: "#7F7F7F",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 8.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.44fdda00e127561c41689f83e62b9797.svg";
export { ForwardRef as ReactComponent };